import clsx from 'clsx'
import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {TeacherContext} from 'teacher/context'

import Question from './question'

const useStyles = makeStyles(questionsStyles)

export default function Questions(props) {

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const {quizQuestionBank: questions, quizNewBankQuestion: question, sectionName, questionId} = context

  return (
    <Box className={classes.root} >
      {questions.map((question, index) => (<Question key={index} {...question} onSelect={props.onSelect} />))}
    </Box>
  )
}

function questionsStyles() {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: 10,
      flexGrow: 1,
    },
  }
}

